import { HttpService } from "@/core";
import { FileReq, FilePageReq, FilePageResp, MoveReq } from "./biz-file.interface";
import axios from "axios";

export class BizFileService {
  static usePageApi() {
    const api = (params: FilePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/biz_file/page",
        params,
      });
    return HttpService.usePagination<FilePageResp>(api);
  }

  static useCreateApi() {
    const api = (files: FileReq[], bizId: string, bizType: string) =>
      HttpService.axios({
        method: "POST",
        url: "/biz_file/newFile",
        data: { bizFiles: files, bizId, bizType },
      });
    return HttpService.useRequest<void>(api);
  }
  static useCreateUploadApi() {
    const api = (files: FileReq[], bizId: string, bizType: string) =>
      HttpService.axios({
        method: "POST",
        url: "/biz_file/addCopy",
        data: { bizFiles: files, bizId, bizType },
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (ids: string[]) =>
      HttpService.axios({
        method: "DELETE",
        url: "/biz_file",
        params: { ids },
      });
    return HttpService.useRequest<void>(api);
  }

  static useMoveApi() {
    const api = (data: MoveReq) =>
    HttpService.axios({
      method: "PUT",
      url: "/biz_file/batchUpdateByIds",
      data,
    });
    return HttpService.useRequest<void>(api);
  }

  static updateDocTime() {
    const api = (id: String) =>
      HttpService.axios({
        method: "PUT",
        url: `/project_folder/time/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static async previewApi(url) {
    // const api = (url: string) =>
    //   HttpService.axios({
    //     method: "GET",
    //     url: url,
    //   });
    // return HttpService.usePagination<FilePageResp>(api);
    return await new Promise(function (resolve, reject) {
      axios.get(url)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }
}
